const loadStatusPageEmbed = function(embedCode) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://' + embedCode + '.statuspage.io/embed/script.js';
  document.body.appendChild(script);
};

const Statuspage = {
  setup: function(embedCode) {
    window.addEventListener('load', function() { loadStatusPageEmbed(embedCode) }, false);
  }
}

module.exports = Statuspage;